import { render, staticRenderFns } from "./NisView.vue?vue&type=template&id=3121c4b7"
import script from "./NisView.vue?vue&type=script&lang=js"
export * from "./NisView.vue?vue&type=script&lang=js"
import style0 from "./NisView.vue?vue&type=style&index=0&id=3121c4b7&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports